import React from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
  };

  const currentLang = i18n.language;

  return (
    <>
      {/* Inline styles for the component */}
      <style>
        {`
          .language-switcher {
            position: fixed;
            bottom: 20px;
            right: 20px;
            background-color: #f9f9f9;
            border-radius: 40px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
            padding: 8px 16px;
            display: flex;
            align-items: center;
            gap: 12px;
            z-index: 1000;
            font-family: 'Segoe UI Emoji', 'Noto Color Emoji', 'Apple Color Emoji', sans-serif;
          }

          .language-button {
            display: flex;
            align-items: center;
            gap: 6px;
            border: none;
            background: transparent;
            font-size: 16px;
            cursor: pointer;
            padding: 6px 10px;
            border-radius: 20px;
            transition: background 0.3s;
          }

          .language-button:hover {
            background-color: #e0e0e0;
          }

          .language-button.active {
            background-color: #e0e0e0;
          }

          .language-flag {
            width: 20px;
            height: 14px;
            object-fit: contain;
          }
        `}
      </style>

      <div className="language-switcher">
        <button
          className={`language-button ${currentLang === "fr" ? "active" : ""}`}
          onClick={() => changeLanguage("fr")}
          aria-label="Switch to French"
        >
          <img
            className="language-flag"
            src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1eb-1f1f7.svg"
            alt="FR"
          />
          <span>Français</span>
        </button>
        <button
          className={`language-button ${currentLang === "ar" ? "active" : ""}`}
          onClick={() => changeLanguage("ar")}
          aria-label="Switch to Arabic"
        >
          <img
            className="language-flag"
            src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f2-1f1e6.svg"
            alt="MA"
          />
          <span>العربية</span>
        </button>
      </div>
    </>
  );
};

export default LanguageSwitcher;
